// import node module libraries
import { Col, Row, Container, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';

// import custom components
import SectionHeadingLeft from 'components/marketing/common/section-headings/SectionHeadingLeft';

// import sub components
import FlowsTabSlider from './FlowsTabSlider';

//import translation
import { useTranslation } from 'react-i18next';

const BrowseConnectors = () => {
	const { t } = useTranslation();
	const title = t('Find your Flow');
	const subtitle = t('Browse Flows');
	const description = `Finde deinen passenden Connector aus unserem stegig wachsenden Portfolio.`;

	return (
		<section className="py-8 py-lg-16 bg-light-gradient-bottom bg-white">
			<Container>
				<SectionHeadingLeft
					title={title}
					description={description}
					subtitle={subtitle}
				/>
				<FlowsTabSlider />
				{/* Col */}
				<Col md={12} sm={12} className="mt-lg-10 mt-4">
					{/* Card*/}
					<Card>
						{/* Card body */}
						<Card.Body>
							<div className="d-lg-flex justify-content-between align-items-center">
								<h4 className="mb-0">{t('Are you missing a Flow?')}</h4>
								<span>
									{t('Let us know, please!')}{' '}
									<Link
										to="/marketing/pages/contact?subject=New%20Flow"
										target="_blank"
									>
										{t('Request a Flow here')}
										<i className="fe fe-arrow-up-right"></i>
									</Link>
								</span>
							</div>
						</Card.Body>
					</Card>
				</Col>
			</Container>
		</section>
	);
};
export default BrowseConnectors;
